import { useEffect, useMemo, useState } from "react";

const CITIES_CLOCK = [
  { name: "Milano", tz: "Europe/Rome" },
  { name: "Monaco", tz: "Europe/Monaco" },
  { name: "Londra", tz: "Europe/London" },
  { name: "Parigi", tz: "Europe/Paris" },
  { name: "Dubai", tz: "Asia/Dubai" },
];

export default function CityClocks() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const formatters = useMemo(
    () =>
      CITIES_CLOCK.map(
        (c) => new Intl.DateTimeFormat("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: c.tz })
      ),
    []
  );

  return (
    <div className="border-b border-pine/10" data-testid="city-clocks">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-4 flex flex-wrap items-center gap-x-8 gap-y-2">
        {CITIES_CLOCK.map((c, i) => (
          <div key={c.name} className="flex items-baseline gap-2.5" data-testid={`clock-${c.name.toLowerCase()}`}>
            <span className="h-1 w-1 rotate-45 bg-gold self-center" aria-hidden="true" />
            <span className="text-[0.62rem] font-semibold uppercase tracking-[0.28em] text-pine/70">{c.name}</span>
            <span className="font-serif text-base text-ink tabular-nums">{formatters[i].format(now)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
